import { Store } from 'redux';

import { FieldServiceRootState } from '@/domains/FieldServiceRootState';
import rootSaga from '@/domains/rootSaga';

import configureStore from './configureStore';

export let store: Store<FieldServiceRootState>;

export const buildStore = () => {
  const configuredStore = configureStore();

  store = configuredStore.store;
  configuredStore.runSaga(rootSaga);

  return { store };
};
